import ApiRoutes from "../../../constants/api-routes";
import { hneAdsApi } from "../../../service";

export const createNewAdsCompany = async (body) =>
  hneAdsApi.post(`${ApiRoutes.CREATE_NEW_COMPANY}`, body);

export const createNewEmailVerification = async (body) =>
  hneAdsApi.post(`${ApiRoutes.CREATE_NEW_EMAIL_VERIFICATION}`, body);

export const resendEmailVerification = async (body) =>
  hneAdsApi.post(`${ApiRoutes.RESEND_EMAIL_VERIFICATION}`, body);

export const verifyEmail = async (body) =>
  hneAdsApi.post(`${ApiRoutes.VERIFY_EMAIL}`, body);

export const updateProfile = async (company_id, body) =>
  hneAdsApi.put(`${ApiRoutes.UPDATE_PROFILE}/${company_id}`, body);
